export default {
    IMAGES_DATA_KEY: "images",
    AUDIOS_DATA_KEY: "audios",
    SPRITE_SHEETS_DATA_KEY: "spriteSheets",
    SPINE_ANIMATION_DATA_KEY: "spineAnimations",
    images: {
        extremelySmallBetsCasinoChipValue0001: "src/assets/images/casino_chips/extremely_small_bets/0_001.png",
        extremelySmallBetsCasinoChipValue0005: "src/assets/images/casino_chips/extremely_small_bets/0_005.png",
        extremelySmallBetsCasinoChipValue001: "src/assets/images/casino_chips/extremely_small_bets/0_01.png",
        extremelySmallBetsCasinoChipValue0025: "src/assets/images/casino_chips/extremely_small_bets/0_025.png",
        extremelySmallBetsCasinoChipValue005: "src/assets/images/casino_chips/extremely_small_bets/0_05.png",
        extremelySmallBetsCasinoChipValue01: "src/assets/images/casino_chips/extremely_small_bets/0_1.png",
        extremelySmallBetsBetButtonValue0001: "src/assets/images/buttons/bet_chips/extremely_small_bets/0_001.png",
        extremelySmallBetsBetButtonValue0005: "src/assets/images/buttons/bet_chips/extremely_small_bets/0_005.png",
        extremelySmallBetsBetButtonValue001: "src/assets/images/buttons/bet_chips/extremely_small_bets/0_01.png",
        extremelySmallBetsBetButtonValue0025: "src/assets/images/buttons/bet_chips/extremely_small_bets/0_025.png",
        extremelySmallBetsBetButtonValue005: "src/assets/images/buttons/bet_chips/extremely_small_bets/0_05.png",
        extremelySmallBetsBetButtonValue01: "src/assets/images/buttons/bet_chips/extremely_small_bets/0_1.png",
        smallBetsCasinoChipValue001: "src/assets/images/casino_chips/smaller_bets/0_01.png",
        smallBetsCasinoChipValue005: "src/assets/images/casino_chips/smaller_bets/0_05.png",
        smallBetsCasinoChipValue01: "src/assets/images/casino_chips/smaller_bets/0_1.png",
        smallBetsCasinoChipValue05: "src/assets/images/casino_chips/smaller_bets/0_5.png",
        smallBetsCasinoChipValue1: "src/assets/images/casino_chips/smaller_bets/1.png",
        smallBetsCasinoChipValue025: "src/assets/images/casino_chips/smaller_bets/0_25.png",
        smallBetsBetButtonValue001: "src/assets/images/buttons/bet_chips/smaller_bets/0_01.png",
        smallBetsBetButtonValue005: "src/assets/images/buttons/bet_chips/smaller_bets/0_05.png",
        smallBetsBetButtonValue01: "src/assets/images/buttons/bet_chips/smaller_bets/0_1.png",
        smallBetsBetButtonValue025: "src/assets/images/buttons/bet_chips/smaller_bets/0_25.png",
        smallBetsBetButtonValue05: "src/assets/images/buttons/bet_chips/smaller_bets/0_5.png",
        smallBetsBetButtonValue1: "src/assets/images/buttons/bet_chips/smaller_bets/1.png",
        casinoChipValue01: "src/assets/images/casino_chips/01.png",
        casinoChipValue05: "src/assets/images/casino_chips/05.png",
        casinoChipValue1: "src/assets/images/casino_chips/1.png",
        casinoChipValue5: "src/assets/images/casino_chips/5.png",
        casinoChipValue10: "src/assets/images/casino_chips/10.png",
        casinoChipValue2_5: "src/assets/images/casino_chips/2_5.png",
        betButtonValue0_1: "src/assets/images/buttons/bet_chips/0_1.png",
        betButtonValue0_5: "src/assets/images/buttons/bet_chips/0_5.png",
        betButtonValue1: "src/assets/images/buttons/bet_chips/1.png",
        betButtonValue2_5: "src/assets/images/buttons/bet_chips/2_5.png",
        betButtonValue5: "src/assets/images/buttons/bet_chips/5.png",
        betButtonValue10: "src/assets/images/buttons/bet_chips/10.png",
        regularNumberBaseState: "src/assets/images/buttons/betsPanel/regularNumber/base.png",
        regularNumberHoverDisableState: "src/assets/images/buttons/betsPanel/regularNumber/hover_disable.png",
        zeroNumberBaseState: "src/assets/images/buttons/betsPanel/zero/base.png",
        zeroNumberHoverDisableState: "src/assets/images/buttons/betsPanel/zero/hover_disable.png",
        columnBaseState: "src/assets/images/buttons/betsPanel/column/base.png",
        columnHoverDisableState: "src/assets/images/buttons/betsPanel/column/hover_disable.png",
        dozenBaseState: "src/assets/images/buttons/betsPanel/dozen/base.png",
        dozenHoverDisableState: "src/assets/images/buttons/betsPanel/dozen/hover_disable.png",
        colorEvenLowBaseState: "src/assets/images/buttons/betsPanel/color-even-low/base.png",
        colorEvenLowHoverDisableState: "src/assets/images/buttons/betsPanel/color-even-low/hover_disable.png",
        invisibleBetPickerButton: "src/assets/images/buttons/betPickerInvisible/base.png",
        lastDrawnNumbersFrame: "src/assets/images/lastDrawnNumbersPanel/frame.png",
        lastDrawnNumbersBlack: "src/assets/images/lastDrawnNumbersPanel/black-background.png",
        lastDrawnNumbersRed: "src/assets/images/lastDrawnNumbersPanel/red-background.png",
        lastDrawnNumbersGreen: "src/assets/images/lastDrawnNumbersPanel/green-background.png",
        payTableCloseBase: "src/assets/images/buttons/payTableClose/base.png",
        payTableCloseHover: "src/assets/images/buttons/payTableClose/hover.png",
        payTableCloseClick: "src/assets/images/buttons/payTableClose/click.png",
        infoBase: "src/assets/images/buttons/info/base.png",
        infoHover: "src/assets/images/buttons/info/hover.png",
        infoClick: "src/assets/images/buttons/info/click.png",
        optionsBase: "src/assets/images/buttons/options/base.png",
        optionsHover: "src/assets/images/buttons/options/hover.png",
        optionsClick: "src/assets/images/buttons/options/click.png",
        payTableArrowBase: "src/assets/images/buttons/arrow/base.png",
        payTableArrowHover: "src/assets/images/buttons/arrow/hover.png",
        payTableArrowInActive: "src/assets/images/buttons/arrow/inActive.png",
        optionsInActive: "src/assets/images/buttons/options/inActive.png",
        optionsBackground: "src/assets/images/optionsBackground.png",
        homeBase: "src/assets/images/buttons/home/base.png",
        homeHover: "src/assets/images/buttons/home/hover.png",
        homeClick: "src/assets/images/buttons/home/click.png",
        homeInActive: "src/assets/images/buttons/home/inActive.png",
        menuBase: "src/assets/images/buttons/menu/base.png",
        menuHover: "src/assets/images/buttons/menu/hover.png",
        menuClick: "src/assets/images/buttons/menu/click.png",
        menuInActive: "src/assets/images/buttons/menu/inActive.png",
        quickSpinBase: "src/assets/images/buttons/quickSpin/base.png",
        quickSpinHover: "src/assets/images/buttons/quickSpin/hover.png",
        quickSpinClick: "src/assets/images/buttons/quickSpin/click.png",
        quickSpinInActive: "src/assets/images/buttons/quickSpin/inActive.png",
        rebetBase: "src/assets/images/buttons/rebet/base.png",
        rebetHover: "src/assets/images/buttons/rebet/hover.png",
        rebetClick: "src/assets/images/buttons/rebet/click.png",
        rebetInActive: "src/assets/images/buttons/rebet/inActive.png",
        volumeOffBase: "src/assets/images/buttons/volume/offBase.png",
        volumeOffHover: "src/assets/images/buttons/volume/offHover.png",
        volumeOffClick: "src/assets/images/buttons/volume/offClick.png",
        volumeOnBase: "src/assets/images/buttons/volume/onBase.png",
        volumeOnHover: "src/assets/images/buttons/volume/onHover.png",
        volumeOnClick: "src/assets/images/buttons/volume/onClick.png",
        spinButtonBase: "src/assets/images/buttons/spin/spinBase.png",
        spinButtonHover: "src/assets/images/buttons/spin/spinHover.png",
        spinButtonClick: "src/assets/images/buttons/spin/spinClick.png",
        quickSpinButtonMenuBase: "src/assets/images/buttons/autoPlaySpin/base.png",
        quickSpinButtonMenuHover: "src/assets/images/buttons/autoPlaySpin/hover.png",
        quickSpinButtonMenuInActive: "src/assets/images/buttons/autoPlaySpin/inActive.png",
        spinButtonInActive: "src/assets/images/buttons/spin/spinInActive.png",
        autoSpinButtonBase: "src/assets/images/buttons/spin/autoSpinBase.png",
        autoSpinButtonHover: "src/assets/images/buttons/spin/autoSpinHover.png",
        autoSpinButtonClick: "src/assets/images/buttons/spin/autoSpinClick.png",
        autoSpinButtonInActive: "src/assets/images/buttons/spin/autoSpinInActive.png",
        quickSpinButtonInActive: "src/assets/images/buttons/spin/quickSpinInActive.png",
        gameBackground: "src/assets/images/gameBackground.png",
        removeBetButton: "src/assets/images/buttons/removeBet/base.png",
        removeBetButtonOnHover: "src/assets/images/buttons/removeBet/hover.png",
        removeBetButtonOnClick: "src/assets/images/buttons/removeBet/click.png",
        removeBetButtonInActive: "src/assets/images/buttons/removeBet/inActive.png",
        removeAllBetsButton: "src/assets/images/buttons/removeAllBets/base.png",
        removeAllBetsOnHoverButton: "src/assets/images/buttons/removeAllBets/hover.png",
        removeAllBetsButtonOnClick: "src/assets/images/buttons/removeAllBets/click.png",
        removeAllBetsButtonInActive: "src/assets/images/buttons/removeAllBets/inActive.png",
        autoPlayButton: "src/assets/images/buttons/autoPlayMenuOpen/auto_play_button_base.png",
        autoPlayButtonOnClick: "src/assets/images/buttons/autoPlayMenuOpen/auto_play_button_onClick.png",
        defaultCheckboxActiveOff: "src/assets/images/buttons/defaultCheckbox/offBase.png",
        defaultCheckboxActiveOffHover: "src/assets/images/buttons/defaultCheckbox/offHover.png",
        defaultCheckboxActiveOn: "src/assets/images/buttons/defaultCheckbox/onBase.png",
        defaultCheckboxActiveOnHover: "src/assets/images/buttons/defaultCheckbox/onHover.png",
        sliderBackgroundActive: "src/assets/images/slider/sliderBackgroundActive.png",
        sliderBackground: "src/assets/images/slider/sliderBackground.png",
        sliderPoint: "src/assets/images/slider/sliderPoint.png",
        autoPlayMenuBackground: "src/assets/images/autoPlayMenuBackground.png",
        betPickerPanelBackground: "src/assets/images/betPickerPanelBackground.png",
        howToPlay1: "src/assets/images/payTable/howToPlay1.png",
        howToPlay2: "src/assets/images/payTable/howToPlay2.png",
    },
    fonts: {
        BernardMtCondensed: "src/assets/fonts/bernard-mt-condensed.ttf",
        RobotoCondensedRegular: "src/assets/fonts/RobotoCondensed-Regular.ttf",
        RobotoRegular: "src/assets/fonts/Roboto-Regular.ttf",
    },
    spriteSheets: {},
    spineAnimations: {
        goldenChips: "src/assets/spineAnimations/goldenChips/goldenChips.json",
        snackBar: "src/assets/spineAnimations/infoPopupAnimation/PopupAnimation.json",
        betPicker: "src/assets/spineAnimations/betPickerAnimation/betPickerAnimation.json",
        spinButtonLoad: "src/assets/spineAnimations/spinButtonLoad/spinButtonLoad.json",
        numberFrameAnimation: "src/assets/spineAnimations/numberFrameAnimation/numberFrameAnimation.json",
        winBannerAnimation: "src/assets/spineAnimations/winBannerAnimation/winBannerAnimation.json",
        rouletteCameraMovement: "src/assets/spineAnimations/rouletteCameraMovement/RouletteCameraMovement.json",
        rouletteFade: "src/assets/spineAnimations/rouletteFadeIn/rouletteFadeIn.json",
        rouletteWheel1: "src/assets/spineAnimations/rouletteAnimation/roulette_option_01.json",
        rouletteWheel1Atlas: "src/assets/spineAnimations/rouletteAnimation/roulette3.atlas",
        rouletteWheel2: "src/assets/spineAnimations/rouletteAnimation/roulette_option_02.json",
        rouletteWheel2Atlas: "src/assets/spineAnimations/rouletteAnimation/roulette3.atlas",
        rouletteWheel3: "src/assets/spineAnimations/rouletteAnimation/roulette_option_03.json",
        rouletteWheel3Atlas: "src/assets/spineAnimations/rouletteAnimation/roulette3.atlas",
        rouletteWheel4: "src/assets/spineAnimations/rouletteAnimation/roulette_option_04.json",
        rouletteWheel4Atlas: "src/assets/spineAnimations/rouletteAnimation/roulette3.atlas",
        rouletteWheel5: "src/assets/spineAnimations/rouletteAnimation/roulette_option_05.json",
        rouletteWheel5Atlas: "src/assets/spineAnimations/rouletteAnimation/roulette3.atlas",
        rouletteWheel6: "src/assets/spineAnimations/rouletteAnimation/roulette_option_06.json",
        rouletteWheel6Atlas: "src/assets/spineAnimations/rouletteAnimation/roulette3.atlas",
        rouletteWheel7: "src/assets/spineAnimations/rouletteAnimation/roulette_option_07.json",
        rouletteWheel7Atlas: "src/assets/spineAnimations/rouletteAnimation/roulette3.atlas",
        rouletteWheel8: "src/assets/spineAnimations/rouletteAnimation/roulette_option_08.json",
        rouletteWheel8Atlas: "src/assets/spineAnimations/rouletteAnimation/roulette3.atlas",
        rouletteWheel9: "src/assets/spineAnimations/rouletteAnimation/roulette_option_09.json",
        rouletteWheel9Atlas: "src/assets/spineAnimations/rouletteAnimation/roulette3.atlas",
        rouletteWheel10: "src/assets/spineAnimations/rouletteAnimation/roulette_option_10.json",
        rouletteWheel10Atlas: "src/assets/spineAnimations/rouletteAnimation/roulette3.atlas",
        rouletteWheel11: "src/assets/spineAnimations/rouletteAnimation/roulette_option_11.json",
        rouletteWheel11Atlas: "src/assets/spineAnimations/rouletteAnimation/roulette3.atlas",
    },
    audios: {
        buttonClicked: "src/assets/audios/Buttons/button_normal.ogg",
        buttonRotaryClicked: "src/assets/audios/Buttons/button_rottary_better.ogg",
        buttonSpinClicked: "src/assets/audios/Buttons/button_spin.ogg",
        firstChipPut: "src/assets/audios/Betting/first_chip.ogg",
        nextChipPut: "src/assets/audios/Betting/next_chips.ogg",
        goldenChipWin: "src/assets/audios/win_golden_chips.ogg",
        backgroundTheme: "src/assets/audios/Soundtrack.ogg",
        tableSlideDown: "src/assets/audios/Table_Slide/table_slide_down.ogg",
        tableSlideUp: "src/assets/audios/Table_Slide/table_slide_up.ogg",
        wheelResult: "src/assets/audios/Wheel/wheel_result.ogg",
        wheelSpin: "src/assets/audios/Wheel/wheel_spin_av.ogg",
    },
    loadingScreen: {
        images: {
            loadingScreenLogo: "src/assets/images/loadingScreen/logo.png",
            loadingBarBack: "src/assets/images/loadingScreen/loading_bar_back.png",
            loadingBarCover: "src/assets/images/loadingScreen/loading_bar_cover.png",
        },
    },
};



// WEBPACK FOOTER //
// ./src/app/configs/data.ts